module.exports = __webpack_public_path__ + "static/media/crucial-ingredient.c9ab6747.jpg";